module.exports = __webpack_public_path__ + "static/media/Braixen_gaussian2.7f21b8dc.png";